import { useRecords } from "./useRecords";
import { useUser } from "./useAuth";
import { endOfDay, startOfDay } from "date-fns";
import { isRoleAdmin, isRoleBackOffice } from "../utils/rolesUtils";
import { SPECIAL_USERS, VIRTUAL_CLINIC_ID } from "../utils/constants";
import { getUserDefaultClinic } from "../utils/getUserDefaultClinic";

type UseUserTodayClinicProps = {
	adminDefaultClinic?: number;
	defaultClinic?: number;
	isScheduleClinicOnly?: boolean;
};
export const useUserTodayClinic = ({ adminDefaultClinic, defaultClinic = 1, isScheduleClinicOnly = false }: UseUserTodayClinicProps) => {
	const { data: currentUser, status: userStatus } = useUser();

	const allClinicsUsers = [
		SPECIAL_USERS.filipa_nfb_director,
		SPECIAL_USERS.shilan,
		SPECIAL_USERS.jorge_perestrelo,
		SPECIAL_USERS.maria_antunes
	];

	const currentUserDefaultClinic = getUserDefaultClinic(currentUser);

	const defaultClinicFinal = currentUserDefaultClinic ?? defaultClinic;
	const fallbackClinic = isScheduleClinicOnly ? undefined : defaultClinicFinal;

	const { data: todaySchedule, status: todayScheduleStatus } = useRecords("schedules", "clinic_id", {
		extraOptions: {
			filter: {
				_and: [
					{ start_date: { _gte: startOfDay(new Date()).toISOString() } },
					{ end_date: { _lte: endOfDay(new Date()).toISOString() } },
					{ user: { id: { _eq: currentUser?.id } } }
				]
			}
		},
		enabled: userStatus === "success"
	});
	if (userStatus !== "success" || !currentUser) return undefined;

	if (currentUser.id === SPECIAL_USERS.reception_porto) return 1;
	if (currentUser.id === SPECIAL_USERS.reception_braga) return 3;
	if (allClinicsUsers.includes(currentUser.id)) return [1, 3];

	if (adminDefaultClinic && isRoleAdmin(currentUser.role.id)) return adminDefaultClinic;

	if (todayScheduleStatus === "error") return fallbackClinic;
	if (todaySchedule?.items?.length === 0) return fallbackClinic;

	const clinic = todaySchedule?.items?.at(-1)?.clinic_id;

	const isTodayScheduleVirtualOffice = clinic === VIRTUAL_CLINIC_ID;
	if (!isScheduleClinicOnly && isRoleBackOffice(currentUser.role.id) && isTodayScheduleVirtualOffice) return defaultClinicFinal;

	return clinic;
};
